// extracted by mini-css-extract-plugin
export default {"howToUseImage":"styles_howToUseImage__iJkhT","title":"styles_title__uK9py"};